import { render } from "./ui-customers.vue?vue&type=template&id=c3f627c2"
import script from "./ui-customers.vue?vue&type=script&lang=js"
export * from "./ui-customers.vue?vue&type=script&lang=js"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__